module.exports = __webpack_public_path__ + "static/img/headBg.cbca58cf.png";